import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getAvailability = async () => {
  const { data } = await api.get("/availability");
  return data;
};

export const createBooking = async (payload) => {
  const { data } = await api.post("/bookings", payload);
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};

export const getCalendarStatus = async () => {
  const { data } = await api.get("/oauth/calendar/status");
  return data;
};

export const getCalendarLoginUrl = async () => {
  const { data } = await api.get("/oauth/calendar/login");
  return data.authorization_url;
};
